import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div id=\"subapp-viewport-toolbar\" class=\"subApp flex sm:justify-between xl:flex-nowrap items-center\"><div class=\"flex flex-col sm:flex-row w-full gap-4 pt-4\"><div class=\"\" id=\"search-container\"></div><div class=\"flex flex-row flex-wrap gap-4 justify-between w-full\"><div class=\"flex flex-row flex-wrap gap-4\"><div id=\"sort-container\"></div><div id=\"column-container\"></div><div id=\"filter-button\"></div></div><div class=\"flex flex-row flex-wrap gap-4\"><div id=\"button-container\"></div><div id=\"export-container\"></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "flex flex-col md:flex-row w-full mt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "filter-container" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div id=\"sub_app_1\" class=\"subApp\"></div><div id=\"uploader-container\" class=\"subApp\"></div><div id=\"subapp-viewport-pagination\" class=\"subApp\"></div><div id=\"multipart-form-container\"></div><div id=\"process-container\"></div><div id=\"workflow-container\"></div>", 6)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  id: "sub_app_1",
  class: "subApp"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

import TopBar from "@/components/TopBar";
import MobileMenu from "@/components/MobileMenu";
import { onMounted, ref, watch } from "vue";
import {useRoute} from "vue-router";
import resolveConfig from "tailwindcss/resolveConfig";
// @ts-ignore
import tailwindConfig from "../../tailwind.config.js";
import MainMenu from "@/components/MainMenu/MainMenu.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Main',
  setup(__props) {

const twConfig = resolveConfig(tailwindConfig);
const style = ref("width:100%");

const position = ref("side");
const currlay = ref("rubick");
const route = useRoute();
const isEagente = ref(false);
const isMainPage = ref(false);

  watch(
    () => route.path,
    (newValue) => {
      checkForEagente()
    }
  );

function checkForEagente() {
  // check to show dashboard
  if(route.path == "/management") {
    isMainPage.value = true;
  } else {
    isMainPage.value = false;
  }



  if(route.path.includes("eagente")) {
    isEagente.value = true;
    const targetOrigin = window.location.origin;
    window.postMessage("forceRouter", targetOrigin);
    /*
    if(document.getElementById("sub-platform") != null) {
      //  @ts-ignore
    document.getElementById("sub-platform").style.height = "";
    }*/
  } else {
    isEagente.value = false;
    /*
    if(document.getElementById("sub-platform") != null) {
      //  @ts-ignore
    document.getElementById("sub-platform").style.height = "72px";
    }*/
  }
}

// TODO check if needed
function checkForSubContainer() {
  if (document.getElementById("sub_app_1") == null) {
    let newDiv = document.createElement("div");
    newDiv.setAttribute("id", "sub_app_1");
    // @ts-ignore
    document.getElementById("mainContainer").appendChild(newDiv);
  }
}

onMounted(() => {
  window.addEventListener("updateTheme", setTheme);

  checkForSubContainer();
  observeWidth();
  setTheme();
  checkForEagente();
});

function setTheme() {
  const themeFromStorage = localStorage.getItem("theme");

  if (!themeFromStorage) {
    currlay.value = "rubick";
    position.value = "side";
    return;
  }

  const theme = JSON.parse(themeFromStorage);
  currlay.value = theme.layout;
  position.value = theme.menuPosition;
}

function observeWidth() {
  const filterElement = document.getElementById("filter-container");

  const resizeObserver = new ResizeObserver(function (entry) {
    const width = entry[0].borderBoxSize[0].inlineSize;
    let mdBreakpoint = twConfig.theme.screens.md;
    mdBreakpoint = Number(mdBreakpoint.substring(0, mdBreakpoint.length - 2));

    if (width === 0 || (width !== 0 && window.innerWidth <= mdBreakpoint)) {
      style.value = `width:100%;`;
    }

    if (width !== 0 && window.innerWidth > mdBreakpoint) {
      style.value = `width:calc(100% - ${width}px);`;
    }
  });

  if (!filterElement) {
    return;
  }

  resizeObserver.observe(filterElement);
}

return (_ctx: any,_cache: any) => {
  const _component_DashboardOverview1 = _resolveComponent("DashboardOverview1")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isEagente.value)
      ? (_openBlock(), _createBlock(_unref(MobileMenu), { key: 0 }))
      : _createCommentVNode("", true),
    (!isEagente.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
      {
        'p-4 sm:px-8 sm:py-': currlay.value === 'rubick',
      },
      {
        'bg-primary md:bg-slate-200 dark:bg-transparent': currlay.value === 'enigma',
      },
      {
        'sm:px-8 p-4 icewall-bg': currlay.value === 'icewall',
        'pl-4': currlay.value === 'tinker',
      },
    ])
        }, [
          ((currlay.value === 'enigma' || currlay.value === 'icewall') && !isEagente.value)
            ? (_openBlock(), _createBlock(_unref(TopBar), {
                key: 0,
                layout: currlay.value
              }, null, 8, ["layout"]))
            : _createCommentVNode("", true),
          ((position.value === 'top') && !isEagente.value)
            ? (_openBlock(), _createBlock(MainMenu, {
                key: 1,
                position: 'top',
                layout: currlay.value
              }, null, 8, ["layout"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([
        {
          'flex mt-[4.7rem] md:mt-0':
            currlay.value !== 'icewall' && currlay.value !== 'enigma',
        },
        {
          'flex relative mt-5 sm:mt-10': currlay.value === 'icewall',
          'before:content-[\'\'] before:top-[5px] before:w-[95%] before:z-[-1] before:rounded-[1.3rem] before:bg-white/10 before:h-full before:-mt-4 before:absolute before:mx-auto before:inset-x-0 before:dark:bg-darkmode-400/50':
            currlay.value === 'icewall',
        },
      ])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([
          'flex w-full',
          {
            ' rounded-[1.3rem] bg-primary dark:bg-darkmode-400':
              currlay.value === 'icewall',
            'before:block before:absolute before:inset-0 before:bg-black/[0.15] before:dark:bg-transparent before:rounded-[1.3rem] before:z-[-1]':
              currlay.value === 'icewall',
            'animate-[0.4s_ease-in-out_0.2s_intro-wrapper] animate-fill-mode-forwards translate-y-[5px]':
              currlay.value === 'icewall',
            'md:pt-[86px]': position.value === 'top' && currlay.value === 'icewall',
          },
        ])
            }, [
              ((position.value === 'side' || position.value === 'simple') && !isEagente.value)
                ? (_openBlock(), _createBlock(MainMenu, {
                    key: 0,
                    position: position.value,
                    layout: currlay.value
                  }, null, 8, ["position", "layout"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                id: "mainContainer",
                class: _normalizeClass([
            'pt-4 px-4 pb-10 min-h-screen',
            {
              'rounded-[30px] min-w-0 flex-1 bg-slate-100 dark:bg-darkmode-700 md:px-[22px] max-w-full md:max-w-auto ':
                currlay.value === 'rubick',
              'before:content-[\'\'] before:w-full before:h-px before:block':
                currlay.value === 'rubick',
            },
            {
              'max-w-full md:max-w-none rounded-t-[30px] md:px-[22px] min-w-0 bg-slate-100 flex-1 md:pt-20 mt-5 md:mt-1 relative dark:bg-darkmode-700':
                currlay.value === 'enigma',
              'before:content-[\'\'] before:w-full before:h-px before:block':
                currlay.value === 'enigma',
            },
            {
              'md:px-[22px] max-w-full md:max-w-auto rounded-[1.3rem] flex-1 min-w-0 shadow-sm bg-slate-100 dark:bg-darkmode-700 ':
                currlay.value === 'icewall',
              'before:w-full before:h-px before:block': currlay.value === 'icewall',
            },
            {
              'rounded-tl-[30px] md:rounded-[35px/50px_0px_0px_0px] min-w-0  md:max-w-none bg-slate-100 flex-1 md:px-6 relative md:ml-4 dark:bg-darkmode-700':
                currlay.value === 'tinker',
              'before:content-[\'\'] before:w-full before:h-px before:block':
                currlay.value === 'tinker',
              'after:content-[\'\'] after:z-[-1] after:rounded-[40px_0px_0px_0px] after:w-full after:inset-y-0 after:absolute after:left-0 after:bg-white/10 after:mt-8 after:-ml-4 after:dark:bg-darkmode-400/50':
                currlay.value === 'tinker',
            },
          ])
              }, [
                ((currlay.value === 'rubick' || currlay.value === 'tinker') && !isEagente.value)
                  ? (_openBlock(), _createBlock(_unref(TopBar), {
                      key: 0,
                      layout: currlay.value
                    }, null, 8, ["layout"]))
                  : _createCommentVNode("", true),
                (isMainPage.value)
                  ? (_openBlock(), _createBlock(_component_DashboardOverview1, { key: 1 }))
                  : _createCommentVNode("", true),
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", {
                    id: "datalist-container",
                    style: _normalizeStyle(style.value)
                  }, null, 4)
                ]),
                _hoisted_4
              ], 2)
            ], 2)
          ], 2)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
  ], 64))
}
}

})